/** Arabic for friction surveys, the operator's return, rubber removals and the planner's figures on the platform. Proposed; pending native aviation review. */
const ar: Record<string, string> = {
  // what the shell says when a board's entry reaches the platform
  "A demonstration survey is never saved on the platform.": "لا يُحفظ مسح العرض التوضيحي على المنصة أبدًا.",
  "Each friction figure must be a number between 0 and 1.5.": "يجب أن تكون كل قيمة احتكاك رقمًا بين 0 و1.5.",
  "Judged against the levels for this device and speed.": "قُيّم مقابل المستويات الخاصة بهذا الجهاز وهذه السرعة.",
  "Survey {id} saved on the platform: {runs} runs, {n} readings.":
    "حُفظ المسح {id} على المنصة: {runs} أشواط، {n} قراءة.",
  "Friction test for RWY {end} saved on the platform.": "حُفظ اختبار الاحتكاك للمدرج {end} على المنصة.",
  "Corrected and filed again from the friction screen.": "صُحّح وقُدّم مجددًا من شاشة الاحتكاك.",
  "{ref} filed on the platform as the operator's return.": "قُدّم {ref} على المنصة بوصفه تقرير المشغّل.",
  "{ref} filed on the platform. The survey it is made against is not held on the platform yet.":
    "قُدّم {ref} على المنصة. المسح الذي أُعدّ على أساسه غير محفوظ على المنصة بعد.",
  "{ref}: removal on RWY {end} saved on the platform.": "{ref}: حُفظت إزالة المطاط على المدرج {end} على المنصة.",
  "{ref}: this removal was already on the platform.": "{ref}: هذه الإزالة موجودة على المنصة مسبقًا.",
  "{ref}: removal record updated on the platform.": "{ref}: حُدّث سجل الإزالة على المنصة.",
  "{ref}: nothing to change on the platform.": "{ref}: لا شيء يتغيّر على المنصة.",
  "Rubber figures": "أرقام المطاط",
  "This airport's rubber figures are saved on the platform.": "حُفظت أرقام المطاط الخاصة بهذا المطار على المنصة.",
  "This airport's rubber figures are saved on the platform. The runway touchdown zones are not mapped yet, so the platform's own forecast cannot use the rates for each end.":
    "حُفظت أرقام المطاط الخاصة بهذا المطار على المنصة. مناطق الملامسة على المدرج غير مرسومة بعد، لذا لا يستطيع توقّع المنصة استخدام المعدّلات لكل طرف.",

  // the banner on /friction and /rubber
  "{s} surveys, {tests} friction tests, {rm} rubber removals and {rt} filed returns on this board are from the platform. The July survey report and the surface condition are built into this screen.":
    "{s} مسوحات و{tests} اختبارات احتكاك و{rm} عمليات إزالة مطاط و{rt} تقارير مقدّمة على هذه اللوحة من المنصة. تقرير مسح يوليو وحالة السطح مضمّنان في هذه الشاشة.",
  "Some records could not be read: {why}": "تعذّرت قراءة بعض السجلات: {why}",

  // on the boards themselves
  "This survey is the issued report built into this screen. It is not held on the platform yet.":
    "هذا المسح هو التقرير الصادر المضمّن في هذه الشاشة، وهو غير محفوظ على المنصة بعد.",
  "No surveys on the record. Add one under IMPORT.": "لا توجد مسوحات في السجل. أضف مسحًا من «استيراد».",
  "No surveys on the record": "لا توجد مسوحات في السجل",
  "ON THE PLATFORM": "على المنصة",
  "This airport's figures": "أرقام هذا المطار",
  "SAVE AS THIS AIRPORT'S FIGURES": "احفظها أرقامًا لهذا المطار",
  "LOAD THE NEWER FIGURES": "حمّل الأرقام الأحدث",
  "Not saved on the platform.": "لم يُحفظ على المنصة.",
  "Saved for this airport.": "محفوظة لهذا المطار.",
  "Not saved for this airport yet.": "لم تُحفظ لهذا المطار بعد.",
  "Changed here. These are what-ifs until saved.": "عُدّلت هنا. هذه افتراضات إلى أن تُحفظ.",
  "Newer figures were saved by a colleague.": "حفظ أحد الزملاء أرقامًا أحدث.",
};

export default ar;
